import * as React from 'react';
import { IAthlete, ITeam } from '../../../../data/types';
import { Row } from '../../../layout/Row';
import { EntityFilter } from '../../../shared/filters/EntityFilter';
import { SearchInput } from '../../../shared/form/SearchInput';
import { Controls, ControlsLeftSide, ControlsRightSide } from '../Controls';
import { ManageGroupPopup } from './ManageGroupPopup';

interface IProps {
  onSearch: (search: string) => void;
  teams: ITeam[];
  teamsLoading: boolean;
  filteredTeams: string[];
  setFilteredTeams: (f: string[]) => void;
  search: string;
  loading: boolean;
  athletes: IAthlete[];
}

export const GroupControls = (props: IProps): React.ReactElement => {
  const clearSearch = (): void => props.onSearch('');
  return !props.loading ? (
    <Controls>
      <ControlsLeftSide>
        <Row>
          <SearchInput
            value={props.search}
            onClear={clearSearch}
            onChange={props.onSearch}
            style={{ margin: '0px' }}
          />
        </Row>
      </ControlsLeftSide>
      <ControlsRightSide style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <ManageGroupPopup />
        <EntityFilter
          level={0}
          teams={props.teams}
          teamsLoading={props.teamsLoading}
          filteredTeams={props.filteredTeams}
          applyTeamFilter={props.setFilteredTeams}
          showTabs={['teams']}
        />
      </ControlsRightSide>
    </Controls>
  ) : null;
};
